export const createPaymentIntent = async (email, content, distribution) => {
  const baseUrl = `${import.meta.env.VITE_CLIENT_API_URL}`.replace(/\/$/, '')
  const response = await fetch(`${baseUrl}/paymentIntent `, {
    method: 'POST',
    body: JSON.stringify({ email, content, distribution }),
  });
  return response.json();
};